type IncomingFeedbackSentimentMap = Record<string, string>;

const incomingFeedbackTrackingMap: IncomingFeedbackSentimentMap = {
  'feedback.sentiment.e:4': 'incoming_love',
  'feedback.sentiment.e:3': 'incoming_like',
  'feedback.sentiment.e:2': 'incoming_neutral',
  'feedback.sentiment.e:1': 'incoming_dislike',
  'feedback.sentiment.e:0': 'incoming_hate',
};

/**
 * Get Feedback name in human readable format.
 */
export function getMappedFeedbackTrackingName(markerName: string): string | undefined {
  const match = markerName.match(/^(feedback\.sentiment\.e:[0-4]{1})/gm);

  if (!match) {
    return markerName;
  }

  const key = match[0];
  return incomingFeedbackTrackingMap[key];
}
